<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 py-0">
              <upload-image-direct
                @inputChanged="uplodeImg_1"
                model="places"
                title="صورة المتجر"
              ></upload-image-direct>
              <!-- End:: Image -->
            </div>
            <!-- Start:: Image -->

            <!-- Start:: Name -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="data.ar.name"
                />
                <label for="name_input" class="form-label">
                  اسم المتجر بالعربي
                </label>
              </div>
            </div>
            <!-- End:: Name -->
            <!-- Start:: Name -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="data.en.name"
                />
                <label for="name_input" class="form-label">
                  اسم المتجر بالانجليزي
                </label>
              </div>
            </div>
            <!-- End:: Name -->

            <!-- Start:: Rating -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.rating"
                />
                <label for="name_input" class="form-label"> تقيم المتجر </label>
              </div>
            </div> -->
            <!-- End:: Rating -->

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> تصنيف المتجر* </label>
                <multiselect
                  v-model="data.place_category"
                  :options="place_categories"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>

            <div class="border py-4">
              <p>مواعيد العمل</p>

              <div class="row" v-for="(work_day, i) in work_days" :key="i">
                <div class="col-lg-12 py-0">
                  <div class="input_wrapper checkbox_input">
                    <v-switch
                      v-model="work_day.enabled"
                      :label="work_day.day.name"
                    ></v-switch>
                  </div>
                </div>
                <template v-if="work_day.enabled">
                  <div
                    class="row"
                    v-for="(time, i2) in work_day.times"
                    :key="i2"
                  >
                    <div class="col-lg-5">
                      <div class="select-wrapper">
                        <div class="input_wrapper my-0 top_label">
                          <label for="" class="form-label"> من </label>
                          <v-menu
                            :ref="(el) => setTimeFromRef(el, i, i2)"
                            v-model="time.time_from_modal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="time.from"
                                label=" "
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="time.time_from_modal"
                              v-model="time.from"
                              full-width
                              format="24hr"
                              @click:minute="saveTimeFrom(time.from, i, i2)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="error"
                                @click="time.time_from_modal = false"
                              >
                                الغاء
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="saveTimeFrom(time.from, i, i2)"
                              >
                                حفظ
                              </v-btn>
                            </v-time-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <div class="select-wrapper">
                        <div class="input_wrapper my-0 top_label">
                          <label for="" class="form-label"> الي </label>
                          <v-menu
                            :ref="(el) => setTimeToRef(el, i, i2)"
                            v-model="time.time_to_modal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="time.to"
                                label=" "
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="time.time_to_modal"
                              v-model="time.to"
                              full-width
                              format="24hr"
                              @click:minute="saveTimeTo(time.to, i, i2)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="error"
                                @click="time.time_to_modal = false"
                              >
                                الغاء
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="saveTimeTo(time.to, i, i2)"
                              >
                                حفظ
                              </v-btn>
                            </v-time-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="col-md col-sm-2">
                      <div
                        class="d-flex align-items-center justify-content-center gap-2 h-100"
                      >
                        <button
                          v-if="work_days[i].times.length < 2"
                          type="button"
                          name="append"
                          @click="appendWorkDayRow(i)"
                        >
                          <i class="fas fa-plus-circle"></i>
                        </button>

                        <button
                          v-if="work_days[i].times.length > 1"
                          type="button"
                          name="append"
                          @click="deleteWorkDayRow(i)"
                        >
                          <i class="fas fa-minus-circle"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <!-- START:: MAP -->
            <div class="col-12 fadeIn">
              <div class="large-map">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    id="autocomplete_ar"
                    placeholder="ابحث على الخريطة"
                    @click="getAddressAr"
                  />
                </div>
                <GmapMap
                  :center="coordinates_to_edit"
                  :zoom="7"
                  :draggable="true"
                  map-type-id="terrain"
                >
                  <GmapMarker
                    :position="coordinates_to_edit"
                    :clickable="true"
                    :draggable="false"
                    @dragend="updateMarker($event.latLng)"
                  />
                  />
                </GmapMap>
              </div>

              <!-- Start:: Is Active -->
              <!-- <div class="col-12 py-0">
                <v-checkbox
                  :label="$t('forms.labels.is_active')"
                  v-model="data.is_active"
                  color="success"
                ></v-checkbox>
              </div> -->
              <!-- End:: Is Active -->
            </div>
            <!-- END:: MAP -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.stores.title"),
          disabled: false,
          href: "/store/show-all",
        },
        {
          text: this.$t("breadcrumb.stores.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data To Send
      data: {
        avatar: null,
        store_image: null,
        restaurant_picture_from_outside: null,
        ar: {
          name: null,
        },
        en: {
          name: null,
        },
        rating: null,
        place_category: null,
        location: null,
        is_active: true,
        time_from_modal: null,
        from: null,
        from_day: null,
        time_to_modal: null,
        to: null,
        to_day: null,
      },
      // START:: MAP
      center: {
        lat: null,
        lng: null,
        location: null,
      },

      // center: {},
      markers: null,
      coordinates_to_edit: { lat: 0, lng: 0, location: null },

      // ========== Fixed Data
      place_categories: [],
      days: [
        {
          value: "Saturday ",
          name: "السبت",
        },
        {
          value: "Sunday  ",
          name: "الأحد",
        },
        {
          value: "Monday  ",
          name: "الأثنين",
        },
        {
          value: "Tuesday  ",
          name: "الثلاثاء",
        },
        {
          value: "Wednesday  ",
          name: "الأربعاء",
        },
        {
          value: "Thursday  ",
          name: "الخميس",
        },
        {
          value: "Friday ",
          name: "الجمعة",
        },
      ],
      work_days: [
        {
          day: {
            value: "saturday ",
            name: "السبت",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "sunday  ",
            name: "الأحد",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "monday  ",
            name: "الأثنين",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "tuesday ",
            name: "الثلاثاء",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "wednesday ",
            name: "الأربعاء",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "thursday ",
            name: "الخميس",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "friday ",
            name: "الجمعة",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
      ],
      timeFromRefs: {},
      timeToRefs: {},
    };
  },

  methods: {
    allowedMinutes: (v) => v >= 0 && v <= 60,
    setTimeFromRef(el, dayIndex, timeIndex) {
      if (!this.timeFromRefs[dayIndex]) {
        this.$set(this.timeFromRefs, dayIndex, {});
      }
      this.$set(this.timeFromRefs[dayIndex], timeIndex, el);
    },
    setTimeToRef(el, dayIndex, timeIndex) {
      if (!this.timeToRefs[dayIndex]) {
        this.$set(this.timeToRefs, dayIndex, {});
      }
      this.$set(this.timeToRefs[dayIndex], timeIndex, el);
    },
    appendWorkDayRow(dayIndex) {
      const newTime = {
        from: null,
        to: null,
      };
      this.work_days[dayIndex].times.push(newTime);
    },
    deleteWorkDayRow(dayIndex) {
      if (this.work_days[dayIndex].times.length > 1) {
        this.work_days[dayIndex].times.pop();
      }
    },
    saveTimeFrom(time, dayIndex, timeIndex) {
      if (this.timeFromRefs[dayIndex]?.[timeIndex]) {
        this.timeFromRefs[dayIndex][timeIndex].save(time);
      }
      this.work_days[dayIndex].times[timeIndex].time_from_modal = false;
    },
    saveTimeTo(time, dayIndex, timeIndex) {
      if (this.timeToRefs[dayIndex]?.[timeIndex]) {
        this.timeToRefs[dayIndex][timeIndex].save(time);
      }
      this.work_days[dayIndex].times[timeIndex].time_to_modal = false;
    },
    updateCoordinates(location) {
      console.log(location);
      this.updateData = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },

    clickMethod(m) {
      console.log(m);
      this.center = m.position;
    },
    // END:: UPDATE LOCATION
    updateMarker(location) {
      console.log(location);
      this.coordinates_to_edit = {
        lat: location.lat(),
        lng: location.lng(),
      };

      // this.henlo = location.lat();
    },
    // ============== Get User Location
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          // this.$axios({
          //   method: "get",
          //   url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyAITrPfT5r_qmCm_8ekZyPmnebGo8o_r18`,
          // })
          //   .then((res) => {
          //     console.log(res.data.results[0].formatted_address);
          //   })
          //   .catch(() => {});

          this.markers = [
            {
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
          ];
          this.center = this.markers[0].position;

          this.coordinates_to_edit.lat = this.center.lat;
          this.coordinates_to_edit.lng = this.center.lng;
        });
      }
    },

    // START:: G-MAP GET ADDRESS
    getAddressAr() {
      var self = this;
      var input = document.getElementById("autocomplete_ar");
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          bounds.extend(place.geometry.location);
          place.geometry.location.lat();
          place.geometry.location.lng();
          place.formatted_address;
          // self.data.address = place.formatted_address;
          // console.log();

          self.coordinates_to_edit = {
            lat: Number(place.geometry.location.lat()),
            lng: Number(place.geometry.location.lng()),
            location: place.formatted_address,
          };

          // self.markers[0].position.lat = place.geometry.location.lat();
          // self.markers[0].position.lng = place.geometry.location.lat();
        });
      });
    },

    // Uplode Image
    uplodeImg_1(obj) {
      this.data.store_image = obj;
    },
    uplodeImg_2(obj) {
      this.data.restaurant_picture_from_outside = obj;
    },
    uplodeImg_3(obj) {
      this.data.commercial_registration = obj;
    },
    uplodeImg_4(obj) {
      this.data.vat_picture = obj;
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.store_image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "صورة المتجر مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.place_category) {
        this.$iziToast.error({
          timeout: 2000,
          message: "تصنيف المتجر مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.work_days.length == 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي اختيار أيام العمل",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.work_days.some((day) => day.times.length == 0)) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي اختيار أوقات العمل",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("image", this.data.store_image);
      if (localStorage.getItem("zoz_dash_country")) {
        const country = JSON.parse(localStorage.getItem("zoz_dash_country"));
        submit_data.append("nationality_id", country.id);
        submit_data.append("country_id", country.id);
      }
      if (this.work_days.length > 0) {
        this.work_days.forEach((work_day, i) => {
          submit_data.append("work_times[" + i + "][day]", work_day.day.value);
          submit_data.append(
            "work_times[" + i + "][enabled]",
            +work_day.enabled
          );
          if (work_day.times.length > 0 && work_day.enabled) {
            work_day.times.forEach((time, index) => {
              submit_data.append(
                "work_times[" + i + "][times][" + index + "][start_time]",
                time.from
              );
              submit_data.append(
                "work_times[" + i + "][times][" + index + "][end_time]",
                time.to
              );
            });
          }
        });
      }
      submit_data.append("place_category_id", this.data.place_category.id);
      submit_data.append("ar[name]", this.data.ar.name);
      submit_data.append("en[name]", this.data.en.name);
      //   submit_data.append("rating", this.data.rating);
      submit_data.append("location", this.coordinates_to_edit.location);
      submit_data.append("lat", this.coordinates_to_edit.lat);
      submit_data.append("lng", this.coordinates_to_edit.lng);

      // submit_data.append("is_active", +this.data.is_active);

      this.$axios({
        method: "POST",
        url: "place/store",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/googlePlace/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    getPlaceCategories() {
      this.$axios.get("store_category_not_paginated").then((res) => {
        this.place_categories = res.data.data.map((el) => {
          return { id: el.id, name: `${el.name}` };
        });
        // console.log(this.place_categories);
      });
    },
    // Empty Form Data
    emptyFormData() {
      this.data.avatar = null;
      this.name = null;
      this.rating = null;
      this.p = null;
      this.country = null;
      this.city = null;
      this.region = null;
      this.password = null;
      this.password_confirmation = null;
    },
  },

  created() {
    // Start:: Fire Methods
    this.getLocation();
    this.getPlaceCategories();
    // End:: Fire Methods
  },
};
</script>
